import { bodyText, eyebrow, figure, mutedText } from './typography'

export type LandingFigure = { label: string; value: string; note: string }

/**
 * Заполнитель пустой строки — неразрывный пробел: обычный по краям блока схлопывается, и строка
 * теряет высоту, из-за чего заглушка выходит ниже настоящего ряда.
 */
const blankLine = '\u00A0'

/**
 * Ряд показателей под первым экраном. Граница отделяет соседей внутри строки, поэтому у первого
 * в строке её быть не должно: на двух колонках это третий показатель, на трёх — только первый.
 */
export const LandingFigureRow = ({ items }: { items: LandingFigure[] }) => (
  <dl className="grid divide-y border-y sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-3">
    {/* Ключ по номеру: показатели заданы страницей списком и местами не меняются, а у заглушки
        подписи пустые — по ним элементы не различить. */}
    {items.map((item, index) => (
      <div
        key={index}
        className="grid content-start gap-1.5 py-7 sm:[&:nth-child(2n)]:border-l sm:[&:nth-child(2n)]:pl-6 lg:py-8 lg:[&:not(:first-child)]:border-l lg:[&:not(:first-child)]:pl-10"
      >
        <dt className={`${eyebrow} ${mutedText}`}>{item.label}</dt>
        <dd className={figure}>{item.value}</dd>
        <dd className={`${bodyText} ${mutedText}`}>{item.note}</dd>
      </div>
    ))}
  </dl>
)

const blankFigure: LandingFigure = { label: blankLine, value: blankLine, note: blankLine }

/**
 * Пока числа не пришли, на их месте стоит такой же ряд из пустых строк. Так место под него
 * занимает та же разметка, и при появлении чисел страница не дёргается.
 *
 * Пустые все три строки, включая подпись: `aria-hidden` убирает заглушку из дерева доступности,
 * но не с экрана — видимое слово вроде «Показатель 1» посетитель успел бы прочитать.
 */
export const LandingFigureRowPlaceholder = () => (
  <div aria-hidden="true">
    <LandingFigureRow items={[blankFigure, blankFigure, blankFigure]} />
  </div>
)
